// WhatIsFree.js
import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';

const WhatIsFree = () => {
  const benefits = [
    'Eligibility assessment based on your background',
    'Discussion of suitable study or work pathways',
    'Explanation of timelines, requirements, and expectations',
    'Honest guidance on whether to proceed'
  ];

  return (
    <section className="py-16 bg-[#F5F8FA]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="max-w-4xl mx-auto">
          {/* Section Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-center mb-8"
          >
            <h2 className="text-3xl md:text-4xl font-semibold text-[#202356] mb-4">
              What Is Free
            </h2>
          </motion.div>

          {/* Free Consultation Card */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-white p-8 rounded-lg shadow-sm"
          >
            <h3 className="text-xl font-semibold text-[#202356] mb-4">
              Free Initial Consultation
            </h3>
            <p className="text-gray-600 text-base font-light leading-relaxed mb-6">
              We offer a free initial consultation to help you understand your options before proceeding.
            </p>

            {/* Benefits List */}
            <div className="mb-6">
              <p className="text-gray-700 text-base font-normal mb-4">
                This includes:
              </p>
              <div className="space-y-3">
                {benefits.map((benefit, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.5, delay: 0.3 + (index * 0.1) }}
                    className="flex items-start gap-3"
                  >
                    <CheckCircle2 size={18} className="text-gray-700 flex-shrink-0 mt-0.5" />
                    <p className="text-gray-700 text-base font-light">
                      {benefit}
                    </p>
                  </motion.div>
                ))}
              </div>
            </div>

            {/* Bottom Note */}
            <p className="text-gray-600 text-sm font-light leading-relaxed">
              There is no obligation to continue after the consultation.
            </p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default WhatIsFree;
